module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.abrirModal()
      }
    }
  }, [_vm._v("\n        Chamados\n      ")]), _vm._v(" "), _c('modal-planilhas-chamados', {
    on: {
      "selecionado": _vm.downloadAnexo
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-352a0148!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planilha/planilhas-adm/ExportChamados.vue
// module id = 974
// module chunks = 1